<template>
  <transition-group name="notifications" tag="div" class="notifications-wrapper">
    <button type="button" v-for="notification in notifications" :key="notification.id" class="notification" :class="notification.class" @click="hide(notification.id)">
      <div class="notification-icon">
        <i :class="`icon-${notification.icon}`"></i>
      </div>

      <div class="notification-text">
        <p class="title">{{ notification.title }}</p>
        <p class="descr">{{ notification.descr }}</p>
      </div>
    </button>
  </transition-group>
</template>

<script setup>
import { inject } from 'vue';
const { notifications, hide } = inject('$notification');
</script>

<style lang="scss">
.notifications-wrapper {
  position: fixed;
  bottom: 50px;
  right: 0px;
  z-index: 99999;

  .notification {
    position: relative;
    width: 350px;
    color: white;
    padding: 25px 20px 25px 26px;
    border-radius: 25px 0px 0px 25px;
    margin-top: 15px;
    margin-left: auto;
    border: none;
    display: block;
    box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.659);

    .notification-icon {
      margin-top: auto;
      margin-right: 15px;
      padding-right: 15px;
      position: absolute;
      top: 50%;
      left: 30px;
      transform: translateY(-50%);

      i {
        &::before {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 2rem;
        }
      }
    }

    .notification-text {
      position: relative;
      text-align: left;
      font-size: 15px;
      margin: 0;
      letter-spacing: 0.04rem;
      padding-left: 60px;

      &::before {
        content: "";
        display: block;
        position: absolute;
        left: 42px;
        top: 50%;
        width: 1px;
        height: 35px;
        transform: translateY(-50%);
      }

      .title {
        font-size: 0.9375rem;
        font-weight: 500;
        text-transform: uppercase;
      }

      .descr {
        font-size: 0.5625rem;
        font-weight: 400;
      }
    }

    &.success {
      background: #60fe06;
      color: #086046;

      .notification-text {
        &::before {
          background-color: #086046;
        }
      }
    }

    &.warning {
      background: #f49a00;
      color: #513300;

      .notification-text {
        &::before {
          background-color: #513300;
        }
      }
    }

    &.error {
      background: #ff0000;

      .notification-text {
        &::before {
          background-color: #fff;
        }
      }
    }
  }
}

.notifications-enter-active,
.notifications-leave-active {
  transition: opacity 250ms ease-in-out, transform 250ms ease-in-out;
}

.notifications-enter-from,
.notifications-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

// XL (1200px)
@media only screen and (min-width: 1200px) {
  .notifications-wrapper {
    bottom: 80px;

    .notification {
      padding: 35px 56px 35px 26px;
      border-radius: 40px 0px 0px 40px;
    }
  }
}
</style>